<script lang="ts" setup>
import type { GameTask } from '~/services'

const { task } = defineProps<{
  task: GameTask
}>()

const taskStore = useTasksStore()
const { taskIcon, startTask, state } = useTasks()

const isDisabled = computed(() => {
  const { startTaskId } = taskStore.state
  return startTaskId && startTaskId !== task?.id
})

const loading = computed(() => {
  return taskStore.state.startTaskId === task?.id && taskStore.state.loading
})

const claimedTasks = computed(() => taskStore.state.claimedTasks)
const alreadyClaimed = computed(() => !!claimedTasks.value.find(t => t.taskId === task.id))

const isDefault = computed(() => !task?.icon?.includes('https'))
</script>

<template>
  <div class="task-default" :class="{ 'claimed-disable': alreadyClaimed }">
    <i v-if="isDefault" v-html="taskIcon(String(task?.icon))" />
    <img v-else :src="task?.icon" alt="task icon">
    <div class="task-default__info">
      {{ task?.title }}

      <div v-if="task?.description" class="task-default__info--desc">
        {{ task?.description }}
      </div>

      <div class="reward">
        +{{ task?.rewardPoints }}
        <i-app-j-points color="#fff" />
      </div>
    </div>

    <task-claim-btn
      :task-id="task?.id"
      :loading="loading"
      :disabled="!!isDisabled"
      :claim-icon="state.claimIcon"
      :claimed="state.claimed"
      @start-task="startTask(task)"
    />
  </div>
</template>
